export enum PublishingSite {
  GTFS = "GTFS",
  ECORRIDOR = "ECORRIDOR",
}
